module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.openOtherSpeciesPopup === true) ? _c('div', {
    staticClass: "modal",
    class: {
      visible: _vm.openOtherSpeciesPopup
    }
  }, [_c('div', {
    staticClass: "frame visible"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h4', [_vm._v("Other wildlife")]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa far fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "items"
  }, _vm._l((_vm.otherSpecies), function(specie) {
    return _c('div', {
      key: specie.speciesid,
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.loadSpecie(specie)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": specie.picture,
        "alt": specie.commonname
      }
    })])
  }))])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54dcd037","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=trkhxoihlnq!./~/string-replace-webpack-plugin/loader.js?id=gism0w5tdia!./src/components/threatened-species/OtherSpeciesPopup.vue
// module id = 812
// module chunks = 0